import config from "@/config.js";
import V from "@/main";
import router from "@/router";
import AmbulanceType from "@/data/AmbulanceTypeList";
import { payNow } from "@/methods/payModule";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .build();

export default {
  namespaced: true,
  state: {
    routeToAmbulance: false,
    details: {
      // name: JSON.parse(localStorage.getItem("userInfo")).first_name,
      // mobile: JSON.parse(localStorage.getItem("userInfo")).mobile,
      isRelifeMember: false,
      serviceType: "paid",
      advFiltervalue: [],
      isReturn: false,
      rideNow: true,
      isWaiting: false,
      bookingDate: dayJS().toISOString(),
      bookingTime: dayJS()
        .add(5, "m")
        .toISOString(),
      type: "Basic",
      for: "self",
      waitingPeriod: 1,
      pickUp: null,
      drop: null,
      waiting: null,
      otherMobile: null,
      otherName: null,
      estimatedDistance: null,
      estimatedDuration: null,
      page: 1,
      records_per_page: 10,
      search_text: ""
    },
    modal: false,
    modalValidated: false,
    mode: "search",
    centerId: null,
    typeList: AmbulanceType,
    charges: []
  },
  getters: {
    DETAILS: state => {
      return state.details;
    }
  },
  mutations: {
    toggle(state, payload) {
      if (payload == "header") {
        state.mode = "search";
      } else {
        state.mode = "book";
      }
      state.modal = !state.modal;
      if (!state.modal) {
        state.details.pickUp = null;
        state.details.drop = null;
        state.typeList = AmbulanceType;
      }
    },
    setAmbulanceRouting(state, isRouting) {
      state.routeToAmbulance = isRouting;
    },
    setDetails(state, details) {
      state.details = details;
    },
    modalMode(state, mode) {
      state.mode = mode;
    },
    setTypeList(state, list) {
      state.typeList = list.map(item => {
        return {
          text: item,
          value: item
        };
      });
    }
  },
  actions: {
    toggle(context, payload) {
      context.commit("toggle", payload);
    },
    setAmbulanceRouting(context, payload) {
      context.commit("setAmbulanceRouting", payload);
    },
    setDetails(context, payload) {
      context.commit("setDetails", payload);
    },
    modalMode(context, payload) {
      context.commit("modalMode", payload);
    },
    setTypeList(context, payload) {
      context.commit("setTypeList", payload);
    },
    pay(context, payload) {
      const successUrl = `${config.APP_URL}dashboard/patient/appointments/ambulance/upcoming`;
      return payNow(V, payload.transactionId, successUrl);
    },
    book(context, proceed = false) {
      let data = context.state.details;
      let userInfo = context.rootState.user.info;
      let date = dayJS(data.bookingDate).format("DD MMM YYYY");
      let time = dayJS(data.bookingTime).format("hh:mm a");

      let booking = {
        user: {
          name: userInfo.first_name,
          mobile: userInfo.mobile
        },
        booking_time: dayJS(`${date} ${time}`).toISOString(),
        center_id: context.state.centerId,
        pickup: {
          address: data.pickUp.address,
          lat: data.pickUp.latitude,
          lng: data.pickUp.longitude
        },
        drop: {
          address: data.drop.address,
          lat: data.drop.latitude,
          lng: data.drop.longitude
        },
        // waiting_time:data.isWaiting ? data.waitingPeriod:undefined,
        is_waiting: data.isWaiting,
        vehicle_type: data.type,
        booked_for: data.for == "self" ? "0" : "1",
        is_return: data.isReturn,
        estimated_km: (data.estimatedDistance / 1000).toFixed(2), // in kms
        estimated_time: data.estimatedDuration // in seconds
      };

      if (data.rideNow) {
        booking.is_now = true;
      }

      if (data.isWaiting) {
        booking.waiting = {
          address: data.waiting.address,
          lat: data.waiting.latitude,
          lng: data.waiting.longitude
        };
        booking.waiting_time = data.waitingPeriod;
        // booking.waiting_time = data.waitingPeriod * 60; // convert hours in minutes
      }

      if (data.for != "self") {
        booking.other = {
          first_name: data.first_name,
          last_name: data.last_name,
          mobile: data.otherMobile || undefined
        };
      }
      if (proceed) {
        booking.proceed = 1;
      }

      return V.$http.post(
        `${config.AMBULANCE_URL}api/v1/book/general`,
        booking,
        {
          headers: {
            Authorization: `Bearer ${localStorage.token}`
          }
        }
      );
    }
  }
};
